import React from "react";
import { Layout } from "../layout/Layout.js";
import { FixedTable } from "../../../packages/ui/table/quick/FixedTable.js";
import { Column } from "../../../packages/ui/table/quick/Column.js";
import { getAnalyticsFiles } from "./analyticsApi.js";
import { Link } from "../../../packages/router/Link.js";
import { useLoadEffect } from "../../../react/load/useLoadEffect.js";

/**
 * Renders analytics file list.
 */
export const AnalyticsPage = () => {
  const result = useLoadEffect("analytics", getAnalyticsFiles);

  const columns: Column<string>[] = [
    {
      title: "Analüütika fail",
      render: (row: string) => <Link to={`/analytics/${row}`}>{row}</Link>
    }
  ];

  return (
    <Layout title="Analüütika" containerWidth="fixed-wide-min">
      <h2>Analüütika</h2>
      {result.state === "success" && <FixedTable columns={columns} rows={result.data} fontSize="tiny" />}
    </Layout>
  );
};
